import React from 'react'
import styled from '@emotion/styled'
import { useTheme } from 'emotion-theming'
import { bool, func } from 'prop-types'
import { Modal } from '@jelly/components'

const ModalContentsWrapper = styled.div`
	padding: 2.5rem 1.25rem;

	${({ theme }) => theme.MQ.M} {
		padding: 2.5rem 3rem;
	}
`
const Title = styled.h2`
	border-bottom: 2px solid rgba(255, 255, 255, 0.2);
	color: ${({ theme }) => theme.colors.white};
	${({ theme }) => theme.fonts.primary};
	font-size: 2rem;
	font-weight: bold;
	letter-spacing: -0.29px;
	line-height: 50px;
	margin: 0 auto;
	padding-bottom: 1rem;
`
const LastUpdated = styled.p`
	color: ${({ theme }) => theme.colors.secondary};
	${({ theme }) => theme.fonts.primarySemiBold};
	font-size: 1rem;
	letter-spacing: -0.14px;
	line-height: 25px;
	margin-bottom: 2rem;
`
const Text = styled.p`
	color: ${({ theme }) => theme.colors.white};
	${({ theme }) => theme.fonts.primary};
	font-size: 14px;
	letter-spacing: 0;
	line-height: 21px;
`

AdvertisingDisclosureModal.propTypes = {
	onClose: func.isRequired,
	show: bool.isRequired,
}
/**
 *	Advertising Disclaimer Modal
 */
export function AdvertisingDisclosureModal({ onClose, show }) {
	const {
		colors: { primary },
	} = useTheme()
	return (
		<Modal
			backgroundColor={primary}
			closeIconColor={'#FFFFFF'}
			closeIconPadding={'24px'}
			isModalVisible={show}
			maxWidth={'850px'}
			onRequestClose={onClose}
			setIsModalVisible={onClose}
		>
			<ModalContentsWrapper>
				<Title>Advertising Disclosure</Title>
				<LastUpdated>Last Updated: August 1, 2021</LastUpdated>
				<Text>
					Business.com strives to provide content that helps business owners make informed decisions to
					support and grow their companies. To do this, we research and recommend products and services that
					fit the needs of a variety of business types. We invest thousands of hours assessing a vast array of
					products and services each year.
				</Text>

				<Text>
					Of course, we are a business too. We need to generate revenue to support the content we create. To
					do this, we have financial relationships with some of the companies we cover. This means that in
					certain cases we take a commission when a reader buys something from one of our partners after
					reading an article on our site, or if we share information with a partner provided to us from
					readers about their needs for a product or service.
				</Text>

				<Text>
					Those relationships do not strictly dictate the advice and recommendations you see on our site.
					While we include our partners in the thousands of products and services we evaluate, the
					recommendations you see on our Best Picks and Review pages are produced independently by our
					editorial team based on their research and expertise.
				</Text>
			</ModalContentsWrapper>
		</Modal>
	)
}
